export function decomposePowerOfTwo(
    x: number,
    callback?: (bit: number, value: boolean) => void,
) {
    const array: Array<number> = []

    let power = 0
    let n = 255 - x
    let y = 255

    while (y !== 0) {
        if ((n & 1) !== 0) {
            if (callback) {
                callback(1 << power, true)
            } else {
                array.push(1 << power)
            }
        } else if (callback) {
            callback(1 << power, false)
        }

        ++power

        n >>>= 1
        y >>>= 1
    }

    return array
}
